<template>
    <v-container fluid class="pa-0 px-3">
        <app-mystaffhome/>
    </v-container>
</template>


<script>

import MyStaffHome from '../../sscomponents/performance/MyStaffHome.vue';

export default {

    components: {
        'app-mystaffhome': MyStaffHome,
    },

    data() {
        return {
        }
    },

    methods: {
    },

    mounted() {

    }
}

</script>

<style scoped>
.outer-container {
    margin: 0;
    padding: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

body {
    margin: 0;
    padding: 0;
}
</style>